import { InputWrapper, InputComponent, InputLabel } from "./styled"

type Props = {
  label?: string | JSX.Element,
  defaultValue?: string
} & React.InputHTMLAttributes<HTMLInputElement>

const Input = ({ label, ...otherProps }: Props) => {
  return (
    <InputWrapper>
      <InputLabel>{ label }</InputLabel>
      <InputComponent {...otherProps}/>
    </InputWrapper>
  )
}

export default Input